import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';
import { format } from 'date-fns';

class SimulationMonitorTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'simulationMonitorTableControl';
	}

	/**
	* @param {string} session
	* @param {number} firstResult
	* @param {number} maxResults
	* @return {Promise<GenericTableDto<NamedDto>>}
	*/
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @return {Promise<any>}
	*/
	getRuns(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getRuns`, {
					name
				})
				.then(response => {
					let optionList = [];
					if (response.data) for (let i = 0; i < response.data.length; i += 1) optionList.push({ id: response.data[i].id, name: format(new Date(response.data[i].ts), 'yyyy.MM.dd. HH:mm:ss') + ' - ' + response.data[i].optimizer_name });
					resolve(optionList)
				})
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @param {number} runId
	* @return {Promise<any>}
	*/
	getTrajectory(name, runId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTrajectory`, {
					name,
					runId
				})
				.then(response => { resolve(response) })
				.catch(reject);
		});
	}
}

export default new SimulationMonitorTableService();